import styled from 'styled-components';

export const WrapperTitle = styled.div`
`;

export const ButtonBlockContainer = styled.div`
    margin-top: ${({theme}) => theme.spacing.l};
`;
